import * as React from 'react';
import { Link } from 'react-router';
import * as _ from 'underscore';

import './layout.less';

export default class Layout extends React.Component<{
    id: string;
    title?: string;
    subtitle?: string;
    background?: string;
}, {}> {

    componentDidMount() {
        document.title = `${ this.props.title } - iBeachResort`;
    }

    render(): JSX.Element {
        return (
            <div className={ `${ this.props.id } page` }>
              <div className="header"
                   style={ this.props.background && { backgroundImage: `url(${ this.props.background })` } }>
                <Link to="/" className="logo"></Link>
                <h1>
                  { this.props.title }
                  <small>
                    { this.props.subtitle &&
                      _.reduce(this.props.subtitle.split('\n'), (s, ln, i) => {
                          if ( i > 0 )
                              s.push( <br key={ `br_${i}` } /> );
                          s.push( ln );

                          return s;
                      }, []) }
                  </small>
                </h1>
              </div>

              <div className="container">
                { this.props.children }
              </div>

              <div className="footer">
                <div className="contacts">
                  <h2>CONTACT US</h2>
                  <p>
                    10450 Gulf Boulevard Treasure Island, FL 33706<br />
                    <b>T.</b> (727) 360-4940 / <b>F.</b> (727) 363-1163
                  </p>
                  <div className="sign-up">
                    <p>Sign up here to receive interesting updates</p>
                    <input type="text" name="name" placeholder="Your name" />
                    <input type="email" name="email" placeholder="Email address" />
                    <button type="submit">Send</button>
                  </div>
                </div>
                <p className="copyright">Copyright &copy; 2015 - 2016 Meiaoju</p>
              </div>
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/Layout.tsx
 **/